function ContactForm(){
    return(
        <div className="contact-form-container">
         
            <form name="contact" netlify netlify-honeypot="bot-field" hidden>
                <input type="text" name="name" />
                <input type="email" name="email" />
                <textarea name="message"></textarea>
            </form>


            <form method="post">
                <input type="hidden" name="form-name" value="contact" />
                <p>
                    <label>
                    Your Name: <input type="text" name="name" />
                    </label>
                </p>
                <p>
                    <label>
                    Your Email: <input type="email" name="email" />
                    </label>
                </p>
                <p>
                    <label>
                    Message: <textarea name="message" />
                    </label>
                </p>
                <p>
                    <button type="submit">Send</button>
                </p>
            </form>
        </div>
    )
};

export default ContactForm;